import React, { useState } from 'react';
import { useCommon } from 'src/domains/common/Common';
import { observer } from 'src/utils/mobx-react';
import { YaspaIframe } from 'src/domains/players/webview/components/WithdrawAndDeposit/yaspa/YaspaIframe';
import {
    DarkLoadingSpinner,
    LoadingSpinner,
} from 'src/domains/layouts/webview/components/loaders/loadingSpinner/LoadingSpinner';
import { DepositFailure } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/depositFailure/DepositFailure';
import { DepositSuccess } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/depositFinalView/depositSuccess/DepositSuccess';
import { YaspaDepositState } from 'src/domains/players/webview/components/WithdrawAndDeposit/yaspa/YaspaDeposit.state';

type BaseYaspaDepositPropType = {
    accountHelperMail: string;
    isSignup: boolean;
    hideDepositSuccess: () => void;
    className?: string;
};

type IframeViewPropsType = BaseYaspaDepositPropType & {
    yaspaView: 'iframe-view';
    src: string;
    onMessage: () => void;
};

type LoadingViewPropsType = BaseYaspaDepositPropType & {
    yaspaView: 'loading-view';
};

type SuccessViewPropsType = BaseYaspaDepositPropType & {
    yaspaView: 'success-view';
};

export type YaspaDepositPropsType = IframeViewPropsType | LoadingViewPropsType | SuccessViewPropsType;

export const YaspaDeposit = observer('YaspaDeposit', (props: YaspaDepositPropsType): JSX.Element => {
    const { className, yaspaView, accountHelperMail, isSignup, hideDepositSuccess } = props;
    const common = useCommon();
    const [state] = useState(() => new YaspaDepositState(common, yaspaView));
    const loadingType = isSignup === true ? <LoadingSpinner /> : <DarkLoadingSpinner />;

    const renderContent = (): JSX.Element => {
        switch (state.step.type) {
            case 'iframe-view':
                if (yaspaView !== 'iframe-view') {
                    return loadingType;
                }
                return (
                    <YaspaIframe
                        className={className}
                        src={props.src}
                        onMessage={props.onMessage}
                    />
                );
            case 'loading-view':
                return loadingType;
            case 'failure-view':
                return (
                    <DepositFailure
                        isSignup={isSignup}
                        issueType={state.step.failType}
                        accountHelperMail={accountHelperMail}
                        transactionCallback={'failWithReceipt' === state.step.failType ? state.step.data : undefined}
                        hideDepositSuccess={hideDepositSuccess}
                    />
                );
            case 'success-view':
                return (
                    <DepositSuccess
                        isSignup={isSignup}
                        balance={state.showBalance}
                        hideDepositSuccess={hideDepositSuccess}
                    />
                );
        }
    };
    return renderContent();
});
